import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { indianTrailConfig } from "./data";

export default function IndianTrailPage() {
  return <CityPageTemplate config={indianTrailConfig} />;
}